import React, { useState, useRef } from "react";
import { Button, Select, Layout } from "antd";
import { useEffect } from "react";
import "./raktkoshDashboard.css";
import Insights from "./Insights";
import BloodCollection from "./bloodCollection.jsx";
import BllodIssue from "./bllodIssue";
import Discard from "./discard";
import TopFive from "./topFive";
import Defaulters from "./defaulter";
import { HistoryOutlined } from "@ant-design/icons";
import axios from "axios";
import { baseURL } from './APIRepo'
const { Option } = Select;
const { Header } = Layout;


function RaktkoshDashboard() {
  const [stateCode, setStateCode] = useState(0);
  const [activeTab, setActiveTab] = useState("tab1");

  const [selectData, setSelectData] = useState([]);
  const [loading, setLoading] = useState(true);
  const childRef1 = useRef(null);
  const childRef2 = useRef(null);

  console.log("base api ",baseURL)

  useEffect(() => {
    const fetchData = async () => {
      const JwtTkn =
        "Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJEaGFpcnlhIn0.OCMcxEK6njp3J4SVfgV1HdDx3_-LiJ0QGaiqzfk1rbYFOIeCpm2A_2kcp1Pvn0iKMcrs0jZOOPDYGQN118z9ug";
      try {
        const headers = {
          Authorization: JwtTkn,
          "Content-Type": "application/json",
        };

        const response = await axios.post(
         `${baseURL}/eRaktkoshUtilities/eraktkosh/getallstates`,  
          {},
          { headers } // Pass headers here
        );

        // Extract stateName and stateCode from the response data
        const data = response.data.map((item) => ({
          label: item.stateName,
          value: item.stateCode.toString(), // Assuming stateCode is a string
        }));

        // Update selectData state with the fetched data
        setSelectData(data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
  };

  const StateOptions = [{ value: 0, label: "All States" }];

  const handleChange = (value) => {
    if (childRef1.current) {
      childRef1.current.fetchData();
    }
    if (childRef2.current) {
      childRef2.current.fetchDataBloodIssue();
    }

    console.log("Dropdown Selected");
    console.log("State code is : " + value);
    setStateCode(value);
  };
  const [entryDate, setEntryDate] = useState(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      const storedEntryDate = sessionStorage.getItem("frtdEDt");
      setEntryDate(storedEntryDate);
    }, 300);

    // Cleanup the timer if the component is unmounted before the timeout completes
    return () => clearTimeout(timer);
  }, []);

  console.log("Session time", entryDate);

  console.log(entryDate); // Use the value as needed

  return (
    <div>
      <Header
        className="antHeader"
        style={{
          height: "50px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          backgroundColor: "#0073b7",
          padding: "0 20px",
        }}
      >
        <div
          style={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}
        >
          <span
            style={{
              color: "white",
              fontWeight: "bold",
              marginRight: 8,
              display: "flex",
              gap: "8px",
            }}
          >
            e-Raktkosh{" "}
            <span style={{ fontSize: "24px", fontWeight: "lighter" }}>|</span>
          </span>
          <span className="miniheading" style={{ color: "white" }}>
            Centralized Blood Bank Management Information System
          </span>
          <h5 className="text-red blink-soft">
            <Button
              type="primary"
              shape="round"
              style={{
                fontWeight: "600",
                fontSize: "11px",
                marginTop: "10px",
                height: "22px",
                backgroundColor: "#EF0107",
                borderColor: "#EF0107",
                marginLeft: 10,
              }}
            >
              BETA
            </Button>
          </h5>
        </div>
        <div
          style={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}
        >
          <span
            className="lstUpdate"
            style={{ color: "white", marginRight: 8, fontSize: "14px" }}
          >
            {" "}
            Last Updated
          </span>
          <Button
            type="default"
            className="clock"
            style={{
              marginRight: 4,
              border: "2px solid #83C5FF",
              borderRadius: "10px",
              height: "25px",
              color: "#07569b",
              fontWeight: "600",
              fontSize: "13px",
            }}
          >
            <HistoryOutlined />
            {entryDate || "0-0-0"}{" "}
          </Button>
        </div>
      </Header>
      <div className="py-3 px-4">
        <div className="mb-3 d-flex align-items-center justify-content-between">
          <div
            className=" gap-2  flex-wrap d-flex"
            style={{ overflowX: "auto" }}
          >
            {" "}
            <div className="button-container">
              <Button
                className="antbtn"
                style={{
                  backgroundColor:
                    activeTab === "tab1" ? "#07569B" : "transparent",
                  color: activeTab === "tab1" ? "white" : "#07569B",
                }}
                onClick={() => handleTabClick("tab1")}
              >
                e-Raktkosh Insights
              </Button>

              <Button
                className="antbtn"
                style={{
                  backgroundColor:
                    activeTab === "tab2" ? "#07569B" : "transparent",
                  color: activeTab === "tab2" ? "white" : "#07569B",
                }}
                onClick={() => handleTabClick("tab2")}
              >
                Blood Collection
              </Button>
              {/* <Button
                className="antbtn"
                style={{
                  backgroundColor:
                    activeTab === "tab3" ? "#07569B" : "transparent",
                  color: activeTab === "tab3" ? "white" : "#07569B",
                }}
                onClick={() => handleTabClick("tab3")}
              >
                Blood Issue
              </Button>
              <Button
                className="antbtn"
                style={{
                  backgroundColor:
                    activeTab === "tab4" ? "#07569B" : "transparent",
                  color: activeTab === "tab4" ? "white" : "#07569B",
                }}
                onClick={() => handleTabClick("tab4")}
              >
                Discard
              </Button>
              <Button
                className="antbtn"
                style={{
                  backgroundColor:
                    activeTab === "tab5" ? "#07569B" : "transparent",
                  color: activeTab === "tab5" ? "white" : "#07569B",
                }}
                onClick={() => handleTabClick("tab5")}
              >
                Top 5
              </Button>
              <Button
                className="antbtn"
                style={{
                  backgroundColor:
                    activeTab === "tab6" ? "#07569B" : "transparent",
                  color: activeTab === "tab6" ? "white" : "#07569B",
                }}
                onClick={() => handleTabClick("tab6")}
              >
                Defaulters
              </Button> */}
            </div>
          </div>
          
          <div className="SelectDiv" >
          <Select
            style={{ width: 214 }}
            placeholder="Select State"
            loading={loading}
            onChange={handleChange} // Add onChange event handler
            onClick={(e) => e.stopPropagation()}
          >
            
      {StateOptions.map(option => (
        <Select.Option key={option.value} value={option.value}>
          {option.label}
        </Select.Option>
      ))}
      
     
      {selectData.map((option, index) => (
        <Select.Option key={index + 1} value={option.value}>
          {option.label}
        </Select.Option>
      ))}
    </Select>
         
        </div>
          
        </div>

        <div className="SelectDiv990"  >
          <Select
            style={{ width: 214 }}
            placeholder="Select State"
            loading={loading}
            onChange={handleChange} 
            onClick={(e) => e.stopPropagation()}
          >
            
      {StateOptions.map(option => (
        <Select.Option key={option.value} value={option.value}>
          {option.label}
        </Select.Option>
      ))}
      
     
      {selectData.map((option, index) => (
        <Select.Option key={index + 1} value={option.value}>
          {option.label}
        </Select.Option>
      ))}
    </Select>
         
        </div>

        
        
       
        <div>
          {activeTab === "tab1" && (
            <div>
              <Insights ref={childRef1} stateCode={stateCode} />
            </div>
          )}
          {activeTab === "tab2" && (
            <div>
              <BloodCollection ref={childRef2} stateCode={stateCode}/>
            </div>
          )}
          {activeTab === "tab3" && (
            <div>
              <BllodIssue />
            </div>
          )}
          {activeTab === "tab4" && (
            <div>
              <Discard />
            </div>
          )}
          {activeTab === "tab5" && (
            <div>
              <TopFive />
            </div>
          )}
          {activeTab === "tab6" && (
            <div>
              <Defaulters />
            </div>
          )}
        </div>
        
      </div>
    </div>
  );
}

export default RaktkoshDashboard;
